import { render, staticRenderFns } from "./BtnDelete.vue?vue&type=template&id=9899bea0&scoped=true"
import script from "./BtnDelete.vue?vue&type=script&lang=js"
export * from "./BtnDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9899bea0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9899bea0')) {
      api.createRecord('9899bea0', component.options)
    } else {
      api.reload('9899bea0', component.options)
    }
    module.hot.accept("./BtnDelete.vue?vue&type=template&id=9899bea0&scoped=true", function () {
      api.rerender('9899bea0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/common/atoms/BtnDelete.vue"
export default component.exports